// Types
import type { ICsvRowGenerator } from '~/shared/import/services/csv-row-generator/types';
import type {
  TBaseImportRow,
  TImportColumnIndexes,
  TAddressImportRow,
} from '~/shared/import/types';
import { EImportParamKey } from '~/shared/import/types';

// Services
import { AddressBasedCsvRowGenerator } from '~/shared/import/services/csv-row-generator/address-based';

export class MultipleAddressCsvRowGenerator
  extends AddressBasedCsvRowGenerator
  implements ICsvRowGenerator<TAddressImportRow>
{
  handle(
    rawData: string[],
    headerIndexes: TImportColumnIndexes,
    selectedSourceName: string | null,
    processedRowsCount: number,
    index: number
  ): TAddressImportRow {
    const row: TBaseImportRow = this.generateBasic(
      rawData,
      headerIndexes,
      selectedSourceName,
      processedRowsCount,
      index
    );
    const addresses: string[] = [
      rawData[headerIndexes[EImportParamKey.ADDRESS_1]],
      rawData[headerIndexes[EImportParamKey.ADDRESS_2]],
      rawData[headerIndexes[EImportParamKey.ADDRESS_3]],
      rawData[headerIndexes[EImportParamKey.ADDRESS_4]],
      rawData[headerIndexes[EImportParamKey.ADDRESS_5]],
      rawData[headerIndexes[EImportParamKey.ADDRESS_6]],
      rawData[headerIndexes[EImportParamKey.ADDRESS_7]],
    ].filter((item: string) => !!item);

    const postcode: string | undefined = addresses
      .map((address: string) => this.extractPostcode(address))
      .find((postcode: string | undefined) => !!postcode);

    return {
      ...row,
      full_address: addresses.join(', '),
      postcode,
    };
  }
}
